import { assoc, compose, dissoc, map, type } from 'ramda'
import { formatApiDate } from '../../../utils/helpers/date'

export const cleanRequest = (id, replies) => {
  const formattedReplies = map(
    compose(
      dissoc('categoryId'),
      dissoc('innerId'),
      dissoc('questionType'),
      dissoc('serviceOrderId'),
      dissoc('serviceOrderInnerId'),
      dissoc('description'),
      item => assoc('notes', item.description || null, item),
      item =>
        type(item.value) === 'Object' || type(item.value) === 'Array'
          ? assoc('value', JSON.stringify(item.value), item)
          : item,
      item =>
        type(item.value) === 'Object' && ['user', 'place', 'asset'].includes(item.questionType)
          ? assoc('value', item.value?.id, item)
          : item,
      item =>
        type(item.value) === 'Array' && ['user', 'place', 'asset'].includes(item.questionType)
          ? assoc(
              'value',
              item.value?.map(item => item.id),
              item
            )
          : item,
      item =>
        type(item.value) === 'Array'
          ? assoc(
              'value',
              map(
                itemValue =>
                  type(itemValue) === 'Object'
                    ? compose(dissoc('documentInnerId'), dissoc('uri'))(itemValue)
                    : itemValue,
                item.value
              ),
              item
            )
          : item,
      item =>
        assoc(
          'documents',
          map(
            document =>
              compose(
                dissoc('base64'),
                dissoc('documentId'),
                dissoc('documentInnerId'),
                dissoc('uri'),
                item => assoc('id', item.documentId, item),
                item => (item.metadata ? assoc('metadata', JSON.stringify(item.metadata), item) : item)
              )(document),
            item.documents
          ),
          item
        )
    ),
    replies
  )

  return { id, replies: formattedReplies, events: [{ statusId: 8, eventDate: formatApiDate(new Date()) }] }
}
